import {
    faQuestionCircle,
    faEnvelope,
    faBuilding,
    faCalendar,
    faCalendarXmark,
    faChartBar,
    faBell,
} from '@fortawesome/free-regular-svg-icons'
import {
    faDashboard,
    faUsers,
    faBars,
    faPhone,
    faSterlingSign,
    faCar,
    faUserLock,
    faBook,
    faBackward,
    faBoxOpen,
} from '@fortawesome/free-solid-svg-icons'
import { NavItem } from '../shared/components/sidebar/nav-item.interface'

export const secureNavItems: NavItem[] = [
    {
        name: 'Classic Surefire (V2)',
        href: 'https://sf.surefiresoftware.co.uk/',
        faIcon: faBackward,
        class: 'border-bottom py-2 mb-2',
    },
    {
        name: 'Dashboard',
        url: '/dashboard',
        faIcon: faDashboard,
    },
    {
        name: 'Sites (Properties)',
        url: '/sites',
        faIcon: faBuilding,
        badge: {
            color: 'info',
            text: 'NEW',
        },
    },
    {
        name: 'Customers',
        url: '/customers',
        faIcon: faUsers,
        children: [
            {
                name: 'Find Customer',
                url: '/customers/all',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Add Customer',
                url: '/customers/0',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Merge Customer',
                url: '/customers/merge',
                icon: 'nav-icon-bullet',
            },
        ],
    },
    {
        name: 'Diary',
        url: '/diary',
        faIcon: faCalendar,
        children: [
            {
                name: 'Calendar',
                url: '/diary/calendar',
                icon: 'nav-icon-bullet',
                permissions: ['DiaryManagement'],
                permissionStrategy: 'disable',
            },
            {
                name: 'Timeline',
                url: '/diary/timeline',
                icon: 'nav-icon-bullet',
                permissions: ['DiaryManagement'],
                permissionStrategy: 'disable',
            },
            {
                name: 'Out of Hours',
                url: '/diary/on-call-diary',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Holidays',
                url: '/diary/holiday',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Absences',
                url: '/diary/absence',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Optimised Routing',
                url: '/diary/optimise-route',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Timeslot SMS',
                url: '/diary/timeslot-sms',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Unallocated',
                url: '/unallocated-appointments',
                icon: 'nav-icon-bullet',
                // attributes: {
                //     disabled: true,
                // },
            },
        ],
    },
    {
        name: 'Posts',
        url: '/posts',
        faIcon: faEnvelope,
        badge: {
            color: 'danger',
            text: '5',
        },
        counterKey: 'posts',
    },
    {
        name: 'Inventory',
        url: '/inventory',
        faIcon: faBoxOpen,
        permissions: ['StockControl'],
        permissionStrategy: 'disable',
        children: [
            {
                name: 'Assets',
                url: '/inventory/assets',
                icon: 'nav-icon-bullet',
                permissions: ['StockControl'],
                permissionStrategy: 'disable',
            },
            {
                name: 'Products',
                url: '/inventory/products',
                icon: 'nav-icon-bullet',
                permissions: ['StockControl'],
                permissionStrategy: 'disable',
            },
            {
                name: 'Locations',
                url: '/inventory/locations',
                icon: 'nav-icon-bullet',
                permissions: ['StockControl'],
                permissionStrategy: 'disable',
            },
            {
                name: 'Transactions',
                url: '/inventory/transactions',
                icon: 'nav-icon-bullet',
                permissions: ['StockControl'],
                permissionStrategy: 'disable',
            },
            {
                name: 'Picklists',
                url: '/inventory/picklists',
                icon: 'nav-icon-bullet',
                permissions: ['StockControl'],
                permissionStrategy: 'disable',
            },
            {
                name: 'Settings',
                url: '/inventory/settings',
                icon: 'nav-icon-bullet',
                permissions: ['StockControl'],
                permissionStrategy: 'disable',
            },
        ],
    },
    {
        name: 'More...',
        faIcon: faBars,
        children: [
            {
                name: 'SSP',
                url: '/ssp',
                icon: 'nav-icon-bullet',
                permissions: ['SSP'],
                permissionStrategy: 'disable',
            },
            {
                name: 'Staff',
                url: '/staff',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Appliance Reminders',
                url: '/appliance-reminders',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Products',
                children: [
                    {
                        name: 'Orders Placed',
                        url: '/orders',
                        icon: 'nav-icon-bullet',
                    },
                    {
                        name: 'Parts Arena',
                        url: '/products/parts-arena',
                        icon: 'nav-icon-bullet',
                    },
                ],
            },
            {
                name: 'Finance Calculator',
                url: '/finance-calculator',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Email History',
                url: '/emails',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'SMS History',
                url: '/sms',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Estimates',
                url: '/estimates',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Air Quotes',
                url: '/air-quotes',
                icon: 'nav-icon-bullet',
                permissions: ['AirQuote'],
                permissionStrategy: 'disable',
            },
            {
                name: 'Smart Quotes',
                url: '/smartquotes',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Wildix',
                url: '/wildix',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Wolseley Order',
                url: '/wolseley-order',
                icon: 'nav-icon-bullet',
                permissions: ['Wolseley'],
                permissionStrategy: 'disable',
            },
        ],
    },
    {
        name: 'Directory',
        url: '/directory',
        faIcon: faPhone,
    },
    {
        name: 'Accounts',
        faIcon: faSterlingSign,
        children: [
            {
                name: 'Accounts Integration',
                url: '/accounts-integration',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Surefire Accounts',
                url: '/surefire-accounts',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Payments',
                url: '/payments',
                icon: 'nav-icon-bullet',
            },
        ],
    },

    {
        name: 'Help',
        url: '/help',
        faIcon: faQuestionCircle,
        children: [
            {
                name: 'Contact Support',
                url: '/help/contact-support',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Surefire Docs',
                href: 'https://surefire-software.gitbook.io/docs/',
                icon: 'nav-icon-bullet',
            },
        ],
    },
    {
        name: 'Vehicle Tracking',
        faIcon: faCar,
        children: [
            {
                name: 'Live Locations',
                url: '/vehicle-tracking/locations',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Daily Log',
                url: '/vehicle-tracking/daily-log',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Timesheet',
                url: '/vehicle-tracking/timesheet',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Route',
                url: '/vehicle-tracking/route',
                icon: 'nav-icon-bullet',
            },
        ],
    },
    {
        name: 'Reports',
        faIcon: faChartBar,
        url: '/reports',
    },

    {
        name: 'Notices',
        faIcon: faBell,
        url: '/notices',
    },
    {
        name: 'Release Notes',
        faIcon: faBook,
        url: '/release-notes',
    },
    {
        title: true,
        name: 'Admin',
        roles: ['ADMIN'],
    },
    {
        name: 'Admin',
        faIcon: faUserLock,
        url: '/admin',
        roles: ['ADMIN'],
    },
    {
        title: true,
        name: 'Support',
        roles: ['SUPPORT'],
    },
    {
        name: 'Support',
        faIcon: faUserLock,
        url: '/support',
        roles: ['SUPPORT'],
    },
    {
        title: true,
        name: 'Billing',
        roles: ['SUPPORT'],
    },
    {
        name: 'Billing',
        faIcon: faUserLock,
        url: '/billing',
        roles: ['SUPPORT'],
    },
]
